module.exports = __webpack_public_path__ + "static/media/year2022_2-tc.692a0b4f.jpg";